var _rect, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChangeProfilePhoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 278,
    viewBox: "0 0 280 278",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 278,
    rx: 5.47778,
    fill: "#F9F9F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 13.5,
    width: 253,
    height: 251,
    rx: 4.97778,
    fill: "white",
    stroke: "#A6A6A6",
    strokeDasharray: "7 7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.841 120.441C125.841 111.236 133.303 103.774 142.508 103.774C151.713 103.774 159.175 111.236 159.175 120.441C159.175 129.646 151.713 137.108 142.508 137.108C133.303 137.108 125.841 129.646 125.841 120.441ZM109.175 162.108C109.175 151.024 131.383 145.441 142.508 145.441C153.633 145.441 175.841 151.024 175.841 162.108V166.274C175.841 168.566 173.966 170.441 171.675 170.441H113.341C111.05 170.441 109.175 168.566 109.175 166.274V162.108Z",
    fill: "#E6E6E6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeProfilePhoto);
export default __webpack_public_path__ + "static/media/change_profile_photo.7e3713d88a5dee1fac219527bbdd693c.svg";
export { ForwardRef as ReactComponent };